import {ClassValue, clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const truncate = (text: string, length: number) => {
  return text.length > length ? text.slice(0, length) + '...' : text;
};

export const formatNumber = (
  number: number,
  locale: string = 'en-US'
): string => {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(number);
};

export const formPreviewHash = (...h: string[]) => {
  const secret = process.env.PREVIEW_SECRET ?? 'preview';
  const str = h.join('') + secret;
  let hash = 5381;
  let i = str.length;
  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i); // hash * 33 + charCode
  }
  return (hash >>> 0).toString(16); // convert to unsigned 32-bit integer and to hexadecimal
};
